import { useDispatch, useSelector } from 'react-redux';
import tokenService from '../services/token';
import { clearInfoUser, selectorInfoUser, setInfoUser, setSessionTimeout } from '../store/slices/infoUserSlice';
import { IPermission, IUser } from '../api/login/loginApi';
import { clearSaveAcccount, setDataAcccount } from '../store/slices/userSlice';
import { clearPermission, selectorPermission, setPermission } from '../store/slices/permissionSlice';

const useInfoUser = () => {
  const dispatch = useDispatch();
  const infoUser = useSelector(selectorInfoUser)
  const permissionSlice = useSelector(selectorPermission)

  const setPermissionData = (data: IPermission[]) => {
    dispatch(setPermission(data))

  };

  const getPermission = () => {
    return permissionSlice
  }
  const setInfoUserData = (data: IUser) => {
    dispatch(setInfoUser(data))
  };

  const setTimeSessionTimeout = (sessionTimeout: number) => {
    dispatch(setSessionTimeout(sessionTimeout))
  };

  const getInfoUser = () => {
    return infoUser
  };

  const setAccountPasswordUser = (username: string, password: string) => {
    dispatch(setDataAcccount({ username, password }))
  }

  const clearAccountPasswordUser = () => {
    dispatch(clearSaveAcccount())
  }

  return {
    setPermissionData,
    getPermission,
    setInfoUserData,
    setTimeSessionTimeout,
    getInfoUser,
    setAccountPasswordUser,
    clearAccountPasswordUser
  };
};

export default useInfoUser;
